// src/components/layout/Footer.js
import React from 'react';
import { motion } from 'framer-motion';
import { FaInstagram, FaLinkedin} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h3>BYTEON Technologies</h3>
            <p>Empowering Businesses Through Bespoke Technology</p>
            <div className="social-links">
              {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <motion.div whileHover={{ y: -3 }}><FaFacebook /></motion.div>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <motion.div whileHover={{ y: -3 }}><FaTwitter /></motion.div>
              </a> */}
              <a href="https://www.instagram.com/byteon_technologies/#" target="_blank" rel="noopener noreferrer">
                <motion.div whileHover={{ y: -3 }}><FaInstagram /></motion.div>
              </a>
              <a href="https://www.linkedin.com/company/byteon/" target="_blank" rel="noopener noreferrer">
                <motion.div whileHover={{ y: -3 }}><FaLinkedin /></motion.div>
              </a>
            </div>
          </div>
          
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/solutions">Projects</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-col">
            <h4>Projects</h4>
            <ul>
              <li><a href="/solutions">Web Development</a></li>
              <li><a href="/solutions">AI & ML</a></li>
              <li><a href="/solutions">Data Engineering</a></li>
              <li><a href="/solutions">Software Developmment</a></li>
            </ul>
          </div>
          
          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul className="contact-info">
              <li>Kundalahalli, Bengaluru</li>
              <li>info@byteonai.com</li>
              <li>+91 890435 8389</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} BYTEON Technologies. All rights reserved.</p>
          <div className="legal-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;